export default __webpack_public_path__ + "static/media/Migrate-documentation.4864a5ef.md";